import { baseUrl } from "@/api/BaseAPIUrl";
import { DataProvider } from "@/api/DataProvider";
import EnvironmentConfigs from "@/configs";
import {
  useAppActions,
  useMessage,
  useTheme,
} from "@/store/selectors/AppSelectors";
import { ThemeConfigProvider } from "@nexus/shared-ui";
import { Layout as AntdLayout, App, message } from "antd";
import { Content } from "antd/es/layout/layout";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useSearchParams } from "react-router";
import { setCookie } from "react-use-cookie";

const Layout = () => {
  const { i18n } = useTranslation();
  const environments = EnvironmentConfigs();
  const [searchParams] = useSearchParams();

  const theme = useTheme();
  const { setTheme, setChangeLanguage } = useAppActions();

  const messageProvider = useMessage();
  const [messageApi, contextHolder] = message.useMessage();

  const onChangeLanguage = (lang: string) => {
    setCookie(".AspNetCore.Culture", `c=${lang}|uic=${lang}`, {
      days: 1,
      domain: environments.cookieDomain,
      Secure: false,
      path: "/",
      SameSite: "Lax",
    });

    setChangeLanguage(lang);

    if (lang !== i18n.language) {
      const idBaseUrl = baseUrl.address.replace("calendar", "id");
      try {
        switch (lang) {
          case "en-US":
            DataProvider.update(
              "v1/users/culture",
              { culture: "en-US" },
              idBaseUrl
            );
            break;
          case "fa-IR":
            DataProvider.update(
              "v1/users/culture",
              { culture: "fa-IR" },
              idBaseUrl
            );
            break;

          default:
            break;
        }
      } catch (error) {
        console.error(error);
      }
      // const subdomain = getSubdomain();

      return i18n.changeLanguage(lang);
    }
  };

  useEffect(() => {
    if (searchParams && searchParams.get("theme")) {
      const themeParam = searchParams.get("theme");
      if (themeParam === "light" || themeParam === "dark") {
        setTheme(themeParam);
      }
    }

    if (searchParams && searchParams.get("culture")) {
      const lang = searchParams.get("culture");

      if (lang === "fa-IR" || lang === "en-US") {
        setCookie(".AspNetCore.Culture", `c=${lang}|uic=${lang}`, {
          days: 1,
          domain: environments.cookieDomain,
          Secure: false,
          path: "/",
          SameSite: "Lax",
        });

        setChangeLanguage(lang);
        i18n.changeLanguage(lang);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, setTheme, setChangeLanguage]);

  useEffect(() => {
    if (searchParams && searchParams.get("culture")) {
      const lang = searchParams.get("culture");
      setCookie(".AspNetCore.Culture", `c=${lang}|uic=${lang}`, {
        days: 1,
        domain: environments.cookieDomain,
        Secure: false,
        path: "/",
        SameSite: "Lax",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams?.get("culture")]);

  useEffect(() => {
    if (messageProvider.type && messageProvider.text) {
      messageApi[messageProvider.type](messageProvider.text);
    }
  }, [messageProvider.id]);

  return (
    <ThemeConfigProvider
      theme={theme}
      direction={i18n.dir()}
      language={i18n.language === "fa-IR" ? "fa-IR" : "en-US"}
      calendar={i18n.language === "fa-IR" ? "jalali" : "georgian"}
    >
      <App>
        <AntdLayout>
          {contextHolder}

          {/* <PrivateRoute onChangeLanguage={onChangeLanguage}> */}
          {/* <button
            onClick={() =>
              onChangeLanguage(i18n.language === "fa-IR" ? "en-US" : "fa-IR")
            }
          >
            lang
          </button> */}
          <Content className="content-wrapper">
            <Outlet />
          </Content>
        </AntdLayout>
        {/* </PrivateRoute> */}
      </App>
    </ThemeConfigProvider>
  );
};

export default Layout;
